import styled from "styled-components";

export const HomeStyle = styled.div`
  /* wrap */
  .wrap {
    width: 100%;
    height: 100vh;
  }

  /* contentContainer */
  .contentContainer {
    width: 100%;
    display: flex;
    height: calc(100vh - 40px);
  }
  .contentContainer.noheader {
    height: calc(100vh);
  }

  /* statusWrap */
  .statusWrap {
    display: flex;
    flex-direction: column;
    background: #ececec;

    .statusItem {
      flex: 1;
      padding: 0 28px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      justify-content: center;
      cursor: pointer;

      h3 {
        font-size: 18px;
        line-height: 24px;
        color: #999999;
        font-weight: 500;
      }

      .newButton {
        border-radius: 50px;
        padding: 2px 12px;
        background: #ff3542;
        margin-top: -44px;

        h5 {
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
        }
      }
    }
    .statusItem.active {
      background: #ffffff;

      h3 {
        font-size: 18px;
        line-height: 24px;
        color: #333333;
      }
    }
  }

  .noDataListWrap {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    align-self: center;
    flex: 1;

    .noDataList {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-content: center;
      flex: 1;

      .title {
        clear: both;

        h3 {
          font-size: 20px;
          line-height: 24px;
          color: #999999;
          font-weight: 500;
        }
      }

      .titleIcon {
        clear: both;
      }
    }
  }

  /* orderWrap */
  .orderWrap {
    background: #fff;
    overflow-y: auto;
    width: 100%;
    flex: 1;

    .orderTitle {
      /* position: sticky;
      margin-top: 1%;
      margin-bottom: auto;
      z-index: 3; */
      top: 0;
      position: sticky;
      width: 100%;
      display: flex;
      background: #ffffff;
      align-items: center;
      justify-content: flex-start;
      padding: 8px 0 8px 3vw;
      gap: 6px;
      z-index: 10;

      .dateButton {
        padding: 8px 36px;
        background: #fff;
        border-radius: 5px;
        color: #333333;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        border: 1px solid #999999;
      }
      .dateButton.active {
        background: #333;
        color: #ffffff;
        border: 1px solid #000000;
      }
    }
  }
`;

export const ButtonStatusStyle = styled.div`
  /* 줄임말 공통 */
  h4.info {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* text공통 */
  h1 {
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333333;
    font-weight: 600;
    white-space: nowrap;
  }
  h2.orderType {
    padding-top: 26px;
    padding-bottom: 4px;
    color: #4dd2ae;
  }
  h4 {
    color: #333333;
    font-weight: 400;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #999999;
  }

  .listRight {
    min-width: 280px;
    width: 280px;
    display: flex;
    gap: 10px !important;
    justify-content: flex-end;

    .circleWrap {
      padding: 10px;
      width: 150px;
      height: 150px;

      @keyframes rotateGradient {
        0% {
          background-position: 0% 0%;
        }
        100% {
          background-position: 100% 100%;
        }
      }

      .donut {
        position: relative;
        width: 100%;
        aspect-ratio: 1/1;
        margin: 0 auto;
        border-radius: 50%;
        position: relative;
        text-align: center;
      }
      .circleContent {
        position: absolute;
        width: 85%;
        aspect-ratio: 1/1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 25%;
        z-index: 1;

        h3 {
          font-weight: 600;
        }
        h5 {
          padding-top: 6px;
          font-weight: 500;
        }
        h5.completeTime {
          color: #999999;
        }
        h5.plus {
          color: #ff3542;
        }
        h5.minus {
          color: #000000;
        }

        .loadingDots {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 6px;
          gap: 12px;

          @keyframes changeColor {
            0% {
              background: #4dd2ae;
            }
            50% {
              background: #d1d1d1;
            }
          }
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #d1d1d1;
            animation: changeColor 2s infinite;
          }
          .dot:nth-child(2) {
            animation-delay: 0.5s;
          }
          .dot:nth-child(3) {
            animation-delay: 1s;
          }
          .dot:nth-child(4) {
            animation-delay: 1.5s;
          }
        }
      }
    }
    .circleContent.cancel {
      padding-top: calc(100% / 3);
    }

    .buttonContainer {
      position: relative;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      height: 150px;
      outline: none;
      box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      h3 {
        color: #ffffff;
        font-weight: 600;
      }

      .buttonWrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        white-space: pre-line;
        position: relative;

        h4 {
          margin-bottom: -20px;
          line-height: 50px;
          color: #ffffff;
        }
        h4.cancel {
          position: absolute;
          top: 100px;
          font-size: 14px;
          line-height: 18px;
          color: #ff3542;
        }
        p {
          font-size: 10px;
          color: #fff;
          font-weight: 600;
        }
      }
    }
    .buttonContainer.delivery {
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
    .buttonContainer.throo {
      background: #5991ff;
      border: 1px solid #5991ff;
    }
    .buttonContainer.packing {
      background: #fd7441;
      border: 1px solid #fd7441;
    }
    .buttonContainer.delivery.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.throo.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.packing.notCheck {
      background: #dffff6;
      h3 {
        color: #4dd2ae;
      }
    }
    .buttonContainer.disabled {
      cursor: default;
      background: #b2b2b2;
      border: 1px solid #b2b2b2;
      box-shadow: none;
    }
    .buttonContainer.disabled.notCheck {
      background: #f0f0f0;
      h3 {
        color: #b2b2b2;
      }
    }
    .buttonContainer.cancel {
      cursor: default;
      border: 1px solid #ff3542;
      background: #ffffff;
      h3 {
        color: #ff3542;
      }
    }

    .timeSelectBox {
      width: 100%;
    }
    .statusDetailText {
      padding: 11px 10px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      font-weight: 500;
      white-space: nowrap;
    }
  }
`;
